import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FinancialSettingsComponent } from './financial-settings.component';
import { AccountTypeService } from '../../account-types/crud-service';

@NgModule({
  declarations: [FinancialSettingsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [FinancialSettingsComponent],
  providers: []
})
export class FinancialSettingsModule { }
